var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "14px",
    viewBox: "0 0 9 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3 Copy 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Avenu---Visual-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.0-About",
    transform: "translate(-625.000000, -4951.000000)",
    fill: "#89C201",
    stroke: "#89C201",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-3",
    transform: "translate(629.500000, 4958.000000) scale(1, -1) translate(-629.500000, -4958.000000) translate(626.000000, 4952.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.93750429,5.38142857 L-0.718273023,5.38142857 C-0.812073705,5.38142857 -0.88952381,5.29571429 -0.88952381,5.19 C-0.88952381,5.08571429 -0.812073705,5 -0.718273023,5 L7.93750429,5 C8.03345636,5 8.11047619,5.08571429 8.11047619,5.19 C8.11047619,5.29571429 8.03345636,5.38142857 7.93750429,5.38142857 Z",
    id: "Fill-1",
    transform: "translate(3.610476, 5.250000) scale(-1, -1) rotate(90.000000) translate(-3.610476, -5.250000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.35297377,12.789441 C5.31529368,12.789441 5.27798301,12.7763506 5.24769117,12.7501698 L1.54322128,9.38459803 C1.51588474,9.35841726 1.5,9.32418086 1.5,9.28893752 C1.5,9.25335852 1.51588474,9.21945778 1.54322128,9.19428396 L5.24879941,5.82871215 C5.30679719,5.77635061 5.400628,5.77635061 5.45677872,5.82871215 C5.51440709,5.8810737 5.51440709,5.96632903 5.45677872,6.01869057 L1.85648319,9.28893752 L5.45677872,12.5601914 C5.51440709,12.612553 5.51440709,12.6978083 5.45677872,12.7501698 C5.42796454,12.7763506 5.39028445,12.789441 5.35297377,12.789441 Z",
    id: "Fill-3",
    transform: "translate(3.500000, 9.289441) scale(-1, -1) rotate(90.000000) translate(-3.500000, -9.289441) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImproved);
export default __webpack_public_path__ + "static/media/improved.4173ad065a17e0570d7bd66f6e2d2969.svg";
export { ForwardRef as ReactComponent };